// import 'lib/open-weather-map-leaflet'
import L from 'leaflet';
import ApexCharts from "apexcharts";
import initMap from "./leaflet-owm-renderer";
import 'webticker/jquery.webticker.min.js'

import {current_weather_icons} from "./weather-icon-hash";

import rainIcon  from '../images/weather-icons/fill/rain.svg'
import compassIcon from '../images/weather-icons/fill/tornado.svg'


const OWM_API_KEY = '5e39307a6f9c493be6a550b9b761cf77';
const MAP_ID = 'cw-banner-map';



const main = () => {

    console.log("rainIcon", compassIcon.toString());
    let cwMap, currentLocationMarkerGroup, marker, accordionParent;
    console.log("Hello from current_weatherAAAAAAAA.js", L)
    
    try {
        cwMap = initMap(MAP_ID);  // initialising heat map
        currentLocationMarkerGroup = L.layerGroup().addTo(cwMap);
        cwMap.setView([53.505, -110.09], 5);
        
    } catch (error) {
        console.error(error);
    }

    // get current location
    $("#checkb-cw-locate").on("click", function() {
        if ($(this).is(":checked")) {
            getCurrentLocation(cwMap, currentLocationMarkerGroup);
            console.log("latitude", $("#" + MAP_ID).attr("data-lat"));
            console.log("longitude", $("#" + MAP_ID).attr("data-lon"));
        } else {
            currentLocationMarkerGroup.clearLayers();
        }
    });

    cwMap.on('click', function(e) {
        L.marker(e.latlng).addTo(currentLocationMarkerGroup);
        $("#cw-lat-inp").val(e.latlng.lat.toFixed(1));
        $("#cw-lon-inp").val(e.latlng.lng.toFixed(1));
    });

    $("#cw-post-latlon-btn").on("click", function() {
        let lat = $("#cw-lat-inp").val();
        let lon = $("#cw-lon-inp").val();
        let limit = 10;
        let variables = [
            "temperature_2m",
            "precipitation",
            "winddirection_10m",
            "weathercode",
        ]
        if (lat && lon) {

            console.log("Getting data with lat and lon: ", lat, lon)
         
            // getting open-meteo current weather and hourly forecast (for 7 days) 
            $.ajax({
                url: `https://api.open-meteo.com/v1/forecast?latitude=${parseFloat(lat)}&longitude=${parseFloat(lon)}&hourly=temperature_2m,relativehumidity_2m,dewpoint_2m,apparent_temperature,precipitation_probability,precipitation,rain,showers,snowfall,snow_depth,weathercode,pressure_msl,surface_pressure,cloudcover,cloudcover_low,cloudcover_mid,cloudcover_high,visibility,evapotranspiration,et0_fao_evapotranspiration,vapor_pressure_deficit,windspeed_10m,windspeed_80m,windspeed_120m,windspeed_180m,winddirection_10m,winddirection_80m,winddirection_120m,winddirection_180m,windgusts_10m,temperature_80m,temperature_120m,temperature_180m,soil_temperature_0cm,soil_temperature_6cm,soil_temperature_18cm,soil_temperature_54cm,soil_moisture_0_1cm,soil_moisture_1_3cm,soil_moisture_3_9cm,soil_moisture_9_27cm,soil_moisture_27_81cm,uv_index,uv_index_clear_sky,is_day,cape,freezinglevel_height,shortwave_radiation,direct_radiation,diffuse_radiation,direct_normal_irradiance,terrestrial_radiation,shortwave_radiation_instant,direct_radiation_instant,diffuse_radiation_instant,direct_normal_irradiance_instant,terrestrial_radiation_instant&current_weather=true&timezone=auto&past_days=3&forecast_days=16&models=best_match`,
                type: "GET",
                dataType: "json",
                success: function(data) {
                    console.log("from-openmeteo-hourly:", data);
                    console.log("variables", Object.keys(data.hourly))
                    
                    $("#cw-lat-inp").val(data.latitude);
                    $("#cw-lon-inp").val(data.longitude);
                    
                    renderCurrentWeatherPlot(data, "#cw-temp-plot-main", "Atmospheric Temperature");
                    renderCurrentWeatherPlot(data, "#cw-temp-plot-soil", "Soil Temperature");

                    renderCurrentWeatherPlot(data, "#cw-precipitation-plot-main", "Precipitation");
                    renderCurrentWeatherPlot(data, "#cw-precipitation-plot-cloudcover", "Cloud Cover");
                    renderCurrentWeatherPlot(data, "#cw-precipitation-plot-snow", "Snow");

                    renderCurrentWeatherPlot(data, "#cw-soil-plot-temp", "Soil Temperature");
                    renderCurrentWeatherPlot(data, "#cw-soil-plot-moisture", "Soil Moisture");

                    renderCurrentWeatherPlot(data, "#cw-air-plot-main", "Air");

                    renderCurrentWeatherPlot(data, "#cw-solar-plot-uvi", "UV Index");
                    renderCurrentWeatherPlot(data, "#cw-solar-plot-radiation", "Solar Radiation");
                },
                error: function(error) {
                    console.error(error);
                }
            });

            // getting location name using lat and lon (openweather reverse geolocation)
            fetch(`https://api.openweathermap.org/geo/1.0/reverse?lat=${lat}&lon=${lon}&limit=${10}&appid=${OWM_API_KEY}`)
                .then(response => response.json())
                .then(data => {
                    console.log("from-openweather-rev-geo:", data);
                    $("#cw-location-name").val(`${data[0].name}, ${data[0].state}, ${data[0].country}`);
                })

            // getting current weather, hourly and daily forecast from openweatherAPI
            fetch(`https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${lon}&units=metric&appid=${OWM_API_KEY}`)
                .then(response => response.json())
                .then(data => {
                    console.log("from-openweaether-forecast:", data);
                    // $("#cw-location-name").val(`${data[0].name}, ${data[0].state}, ${data[0].country}`);
                    renderWeatherAlertToasts(data);
                    $("#cw-desc-container").fadeIn(1000);
                    
                    $("#cw-datetime").html(`${getDateTimeString(data.current.dt)}`);
                    $("#cw-status-icon").attr("src", current_weather_icons.fill.ow_weathercodes[data.current.weather[0].icon]);
                    $("#cw-status-main").html(`${data.current.weather[0].main}`)
                    $("#cw-status-desc").html(`${data.current.weather[0].description}`)
                    $("#cw-temp").html(`${data.current.temp}°C`);
                    $("#cw-feels-like").html(`${data.current.feels_like}°C`);
                    $("#cw-sunrise").html(`\n${new Date(data.current.sunrise * 1000).toLocaleTimeString()}`);
                    $("#cw-sunset").html(`\n${new Date(data.current.sunset * 1000).toLocaleTimeString()}`);
                    
                    $("#cw-humidity").html(`${data.current.humidity}%`);
                    $("#cw-dew-point").html(`${data.current.dew_point}°C`);
                    $("#cw-pressure").html(`${data.current.pressure} hPa`);
                    $("#cw-clouds").html(`${data.current.clouds}%`);
                    $("#cw-visibility").html(`${data.current.visibility} m`);
                    $("#cw-wind-speed").html(`${data.current.wind_speed} m/s`);
                    $("#cw-wind-deg").html(`${data.current.wind_deg}°`);
                    $("#cw-wind-gust").html(`${data.current.wind_gus ? data.current.wind_gust : "Unavailable"} m/s`);
                    $("#cw-uvi").html(`${data.current.uvi}`);

                    // current weather small ticker
                    $("#webticker-cw-small-ticker").webTicker({
                        speed: 60, // Pixels per second
                        duplicate: true,  // determines if tickers should wrap around before one lap ends
                        height: '100%',
                        // updatetype: 'update',
                    });
                }
            )

            // getting daily forecast from open-meteo
            fetch(`https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&daily=weathercode,temperature_2m_max,temperature_2m_min,apparent_temperature_max,apparent_temperature_min,sunrise,sunset,uv_index_max,uv_index_clear_sky_max,precipitation_sum,rain_sum,showers_sum,snowfall_sum,precipitation_hours,precipitation_probability_max,windspeed_10m_max,windgusts_10m_max,winddirection_10m_dominant,shortwave_radiation_sum,et0_fao_evapotranspiration&timezone=auto&forecast_days=16&models=best_match`)
                .then(response => response.json())
                .then(data => {
                    console.log("from-openmeteo-daily:", data);
                    
                    accordionParent = $("#cw-accordion-parent")
                    accordionParent.empty();
                    for (let i = 0; i < data.daily.time.length; i++) {
                        let accordionItem = $('<div class="accordion-item"></div>');
                        let accordionHeader = $(`<h2 class="accordion-header" id="cw-accordion-heading-${i}"></h2>`);
                        let accordionCollapse = $(`<div id="cw-collapse-${i}" class="accordion-collapse collapse" aria-labelledby="cw-accordion-heading-${i}" data-bs-parent="#cw-accordion-parent"></div>`);
                        let accordionBody = $(`<div class="accordion-body"></div>`);
                        let accordionBodyDesc = $(`<div></div>`);
                        
                        let accordionButton = $(`<button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#cw-collapse-${i}" aria-expanded="true" aria-controls="cw-collapse-${i}"></button>`);
                        let dayString = `<h4>${formatDate(data.daily.time[i])}</h4>`;
                        let dailyIcon = $(`<img class="cw-daily-icon" src="${current_weather_icons.fill[`o-meteo-wc-${data.daily.weathercode[i]}`]}" alt="weather-icon">`);
                        let maxMinTemp = $(`<h4 class="fs-4">${data.daily.temperature_2m_max[i]}°C / ${data.daily.temperature_2m_min[i]}°C</h4>`);
                        
                        Object.keys(data.daily).forEach(key => {
                            if (data.daily[key][i] != null) {
                                console.log(data.daily[key][i])
                                let row = $(`<div class="row h4">${key} = ${data.daily[key][i]} ${data.daily_units[key][i] ? data.daily_units[key][i] : ""}</div>`);
                                accordionBodyDesc.append(row);
                            }
                        })

                        accordionBody.append(accordionBodyDesc);
                        accordionButton.append(maxMinTemp, dailyIcon, dayString)
                        accordionHeader.append(accordionButton);
                        accordionCollapse.append(accordionBody);    
                        accordionItem.append(accordionHeader, accordionCollapse);
                        accordionParent.append(accordionItem);

                    }

                })

        }    
    });
}

main();



function formatDate(dateString) {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    
    let date = new Date(dateString);
    
    let day = days[date.getDay()];
    let month = months[date.getMonth()];
    let dateNumber = date.getDate();
    let year = date.getFullYear();
    
    return `${day}, ${dateNumber} ${month} ${year}`;
  }
  

function getDateTimeString(unix_timestamp) {
    var date = new Date(unix_timestamp * 1000); // JavaScript uses milliseconds
    
    var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    
    var dayOfWeek = days[date.getDay()];
    var dayOfMonth = date.getDate();
    var month = months[date.getMonth()];
    var year = date.getFullYear();
    
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    
    var strTime = hours + ':' + minutes + ' ' + ampm;
    
    var formattedDate = dayOfWeek + ', ' + dayOfMonth + ' ' + month + ', ' + year + ', ' + strTime;
    
    return formattedDate;
    
}


function renderCurrentWeatherPlot(data, divId, type) {
    let title, ylabel;
    let variables = [
        [
            "temperature_2m",
            "temperature_80m",
            "temperature_120m",
            "temperature_180m",
            "apparent_temperature",
            "dewpoint_2m",
        ],
        [
            'precipitation_probability', 
            'precipitation', 
            'rain', 
            'showers',  
        ],
        
        [
            'soil_moisture_0_1cm', 
            'soil_moisture_1_3cm', 
            'soil_moisture_3_9cm', 
            'soil_moisture_9_27cm', 
            'soil_moisture_27_81cm', 
        ],
        [
            'relativehumidity_2m', 
            // 'freezinglevel_height',
            // 'dewpoint_2m', 
            'evapotranspiration', 
            // 'et0_fao_evapotranspiration', 
            // 'pressure_msl', 
            'surface_pressure', 
            // 'vapor_pressure_deficit', 
            'visibility',
        ],
        [
            'uv_index', 
            'uv_index_clear_sky', 
        ],
        [
            "snowfall",
            "snow_depth",
        ],
        [
            "soil_temperature_0cm",
            "soil_temperature_6cm",
            "soil_temperature_18cm",
            "soil_temperature_54cm",
        ],
        [
            'cloudcover', 
            'cloudcover_low', 
            'cloudcover_mid', 
            'cloudcover_high',
        ],
        [
            'shortwave_radiation', 
            'direct_radiation', 
            'diffuse_radiation', 
            'direct_normal_irradiance', 
            'terrestrial_radiation', 
            'shortwave_radiation_instant', 
            // 'direct_radiation_instant', 
            // 'diffuse_radiation_instant', 
            // 'direct_normal_irradiance_instant', 
            // 'terrestrial_radiation_instant',
        ],
    ]
    switch (type) {
        case "Atmospheric Temperature":
            variables = variables[0]
            ylabel = "Degrees Celsius"
            break;
        case "Precipitation":
            variables = variables[1]
            ylabel = "millimeters"
            break;
        case "Soil Moisture":
            variables = variables[2]
            ylabel = `Water Fraction by Volume (m${String.fromCharCode(178)}/m${String.fromCharCode(178)})`   
            break;
        case "Air":
            variables = variables[3]
            break;
        case "UV Index":
            variables = variables[4]
            break;
        case "Snow":
            variables = variables[5]
            ylabel = "millimeters"
            break;
        case "Soil Temperature":
            variables = variables[6]
            ylabel = "Degrees Celsius"
            break;
        case "Cloud Cover":
            variables = variables[7]
            ylabel = "Percentage"
            break;
        case "Solar Radiation":
            variables = variables[8]
            ylabel = `Watts per square meter (W/m${String.fromCharCode(178)})`
            break;
        default:
            variables = variables[1]
            break;
    }

    let d = {}
    variables.forEach(variable => {
        d[variable] = data.hourly[variable].map((x, i) => [data.hourly.time[i], x])
    })
    
    let today = new Date();
    let indexOfToday = getLastPassedTime(data['hourly']['time'], today);
    let forecaseCount = data['hourly']['time'].length - indexOfToday - 1;
    console.log("forecaseCount", forecaseCount, indexOfToday, today.getTime()/1000, today)
    
    let options = {
    series: Object.keys(d).map(variable => {
            return {
                name: variable,
                data: d[variable]
            }
        }),

    annotations: {
        xaxis: [
          {
            x: new Date().getTime(),
            x2: new Date().getTime() + 24 * 60 * 60 * 1000 * 16,
            fillColor: '#B3F7CA',
            opacity: 0.3,
            label: {
                // offsetY: 60,
                text: 'Forecast',
                style: {
                    fontFamily: 'Maven Pro, sans-serif',
                }
            }
          }
        ]
    },

    noData: {
        text: 'Get Weather Data to Plot Here...',
        style: {
            fontSize: '24px',
            fontFamily: 'Maven Pro, sans-serif',
            color: '#263238'
        }
    },
    
    chart: {
    type: 'line',
    stacked: false,
    height: 500,
    zoom: {
        type: 'x',
        enabled: true,
        autoScaleYaxis: true
    },
    toolbar: {
        autoSelected: 'pan',
    }
    },

    forecastDataPoints: {
        count: forecaseCount
    },

    dataLabels: {
    enabled: false
    },

    stroke: {
        width: new Array(Object.keys(d).length).fill(3.5),
    },

    markers: {
    size: 0,
    },

    // colors: ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0", "#546E7A", "#26a69a", "#D10CE8", "#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0", "#546E7A", "#26a69a", "#D10CE8"],

    title: {
    text: type,
    align: 'left'
    },

    yaxis: {
    title: {
        text: ylabel
    },
    },

    xaxis: {
    type: 'datetime',
    labels: {
        formatter: function (val) {
            return new Date(val).toLocaleString();
        }
    }
    // min: new Date().getTime() - 24 * 60 * 60 * 1000 * 1,
    // max: new Date().getTime() + 24 * 60 * 60 * 1000 * 3,
    },

    tooltip: {
    shared: false,
    // formatter: function (val, opts) {
    //     return `${opts.w.globals.seriesNames[opts.seriesIndex]}: ${val}°C`
    // }
    }
    };

    var chart = new ApexCharts(document.querySelector(divId), options);
    // chart.zoomX(new Date().getTime(), new Date().getTime() + 24 * 60 * 60 * 1000)
    chart.render();
    
    
  
  

}


function getLastPassedTime(arrayofTimes, time) {
    let lastIndex = -1;
    let currentDate = new Date(time);
    for (let i = 0; i < arrayofTimes.length; i++) {
        let time = new Date(arrayofTimes[i]);
        if (time <= currentDate) {
            lastIndex = i;
        } else {
            break;
        }
    }
    return lastIndex;
}


function renderWeatherAlertToasts(data) {
    if (data.alerts) {
        data.alerts.forEach((alert, index) => {
            let toast = $('<div>').addClass('toast').attr({
                role: 'alert',
                'aria-live': 'assertive',
                'aria-atomic': 'true',
                id: `cw-toast-${index}`
            });
            
            var toastHeader = $('<div>')
                                .addClass('toast-header')
                                .addClass('bg-danger')
                                .addClass('text-white')
                                .addClass('fs-4');
            let dangerIcon = $('<i>')
                .addClass('bi bi-exclamation-triangle-fill')
                .html('&nbsp;')
            let headerText = $('<strong>')
                                .addClass('me-auto')
                                .text(`Weather Alert - ${alert.event.toUpperCase()}`)
                                .addClass('text-decoration-underline');
            var button = $('<button>').addClass('btn-close').attr({
                type: 'button',
                'data-bs-dismiss': 'toast',
                'aria-label': 'Close',
                id: `toast-cls-${index}`
            });
            
            toastHeader.append(dangerIcon, headerText, button);
            
            var toastBody = $('<div>').addClass('toast-body')
                .addClass('fs-4')
                .addClass('bg-light')
                .css('line-height', 'normal')
                .text(`${alert.description}`);
            
            let footer = $('<div>')
                .addClass('card-footer')
                .addClass('text-muted')
                .addClass('text-end')
                .text(`${alert.sender_name} [${new Date(alert.start * 1000).toLocaleString()} - ${new Date(alert.end * 1000).toLocaleString()}]`)

            toast.append(toastHeader, toastBody, footer);
            $("#cw-toasts-container").append(toast);
            $(`#cw-toast-${index}`).fadeIn(500);
            $(`#toast-cls-${index}`).on("click", function() {
                $(`#cw-toast-${index}`).fadeOut(500);
            })
        })
    }

}


function getCurrentLocation(mapObj, markerLayerGroup) {

    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
            let latitude = position.coords.latitude;
            let longitude = position.coords.longitude;
            mapObj.flyTo([latitude, longitude], 11)
            L.marker([latitude, longitude]).addTo(markerLayerGroup);
            $("#cw-lat-inp").val(latitude.toFixed(1));
            $("#cw-lon-inp").val(longitude.toFixed(1));
            
        }, function(error) {
            console.error(error);
        });
    } else {
        console.log("Geolocation is not supported by this browser.");
    }
}

